{
  "appName": "Login Page",
  "entryFile": "./app-entry.jsx",
  "entryName": "login-page",
  "rootUrl": "/sign-in",
  "e2eTestsDisabled": false,
  "productId": "40839364-43fa-454a-b29a-bc333ad63e1f"
}